import RenderMonitor from '../RenderMonitor';
import ManagerOverviewPanel from '../manager/ManagerOverviewPanel';

function AnalyticsPageShell({
  hierarchy,
  renderMonitorName,
  overviewCacheNamespace,
  landingSubtitle = 'Activity overviews across all clients',
  emptyClientsMessage = null,
  showUserLevel = true,
}) {
  const {
    clientId,
    regionId,
    teamId,
    userId,
    selectedClient,
    selectedRegion,
    selectedTeam,
    selectedUser,
    setClient,
    setRegion,
    setTeam,
    setUser,
    loading,
    error,
    clients = [],
  } = hierarchy;

  const headerName = (showUserLevel && selectedUser?.displayName)
    || selectedTeam?.name
    || selectedRegion?.name
    || selectedClient?.business_name
    || null;

  const pageTitle = headerName ? `${headerName} analytics` : 'Analytics';
  const pageSubtitle = headerName ? 'Activity Overview' : landingSubtitle;

  const handleBack = () => {
    if (showUserLevel && userId) setUser('');
    else if (teamId) setTeam('');
    else if (regionId) setRegion('');
    else if (clientId) setClient('');
  };

  const backLabel = showUserLevel && userId
    ? `← ${selectedTeam?.name || 'Team'}`
    : teamId
      ? `← ${selectedRegion?.name || 'Region'}`
      : regionId
        ? `← ${selectedClient?.business_name || 'Client'}`
        : '← All clients';

  if (!loading && emptyClientsMessage && clients.length === 0) {
    return (
      <div className="dashboard-page">
        <RenderMonitor componentName={renderMonitorName} />
        <div className="modern-card" style={{ color: '#64748b' }}>{emptyClientsMessage}</div>
      </div>
    );
  }

  return (
    <div className="dashboard-page">
      <RenderMonitor componentName={renderMonitorName} />
      {clientId && (
        <button type="button" className="analytics-back-link" onClick={handleBack}>
          {backLabel}
        </button>
      )}
      <div className="modern-mb-6">
        <h1 className="modern-title">{pageTitle}</h1>
        <p className="modern-subtitle">{pageSubtitle}</p>
      </div>
      {error && !loading ? (
        <div className="modern-error">{error}</div>
      ) : (
        <ManagerOverviewPanel
          hierarchy={hierarchy}
          overviewCacheNamespace={overviewCacheNamespace}
        />
      )}
    </div>
  );
}

export default AnalyticsPageShell;
